function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function () {
  'use strict';

  //TODO: Need to really pear this down and untangle unnecessary controllers
  // as well as create/remove API endpoints that will either not exist or be not needed.
  angular.module('wsLrs.controllers').factory("BadgeUtils", ['$q', function ($q) {
    var cachedPromises = {};
    return {
      clearCachedPromises: function clearCachedPromises() {
        cachedPromises = {};
      },
      /*jshint camelcase: false */
      fetchSearchSuggestions: function fetchSearchSuggestions(params, $scope) {
        var deferred = $q.defer();
        var matches = _.filter($scope.cachedListerItems, function (x) {
          var name = x.name.toLowerCase();
          var searchString = params.in_name.toLowerCase();
          return name.indexOf(searchString) > -1;
        });
        deferred.resolve({
          "results": matches
        });
        return deferred.promise;
      }
    };
  }]).service('BadgePermissionSvc', ['$q', 'AppPermissions', 'Badges', 'Logger', function ($q, AppPermissions, Badges, Logger) {
    var self = {
      __badges: null,
      __permissionMap: null,
      fetch: function fetch(_ref) {
        var _limit = _ref._limit,
          _offset = _ref._offset,
          searchText = _ref.searchText,
          order_by = _ref.order_by;
        return Badges.list({
          _limit: _limit,
          _offset: _offset,
          searchText: searchText,
          order_by: order_by
        }).then(function getBadgesSuccess(data) {
          self.__badges = data;
          return self.fetchPermissions().then(function getPermissionsSuccess() {
            // map permissions onto each badge object
            _.each(self.__badges, function (badge) {
              badge.permissions = self.get(badge.id);
            });
            return {
              badges: self.__badges
            };
          });
        }, function getBadgesError(response) {
          self.__badges = null;
          Logger.error("Badges fetch failed with response status " + response.status);
          return [];
        });
      },
      fetchPermissions: function fetchPermissions() {
        if (!self.__permissionMap) {
          self.__permissionMap = {};
          return AppPermissions.getPermissions('badge').then(function getPermissionsSuccess(badgePermissions) {
            self.__permissionMap = badgePermissions;
          });
        } else {
          return $q.resolve();
        }
      },
      get: function get(id) {
        return {
          permissions: self.getPermissions(id),
          people: self.getPeople(id),
          groups: self.getGroups(id),
          hasGlobalGroup: self.getHasGlobalGroup(id)
        };
      },
      getPermissions: function getPermissions(id) {
        return _.has(self.__permissionMap, id) ? self.__permissionMap[id].permissions : [];
      },
      getPeople: function getPeople(id) {
        return _.has(self.__permissionMap, id) ? self.__permissionMap[id].people : [];
      },
      getGroups: function getGroups(id) {
        return _.has(self.__permissionMap, id) ? self.__permissionMap[id].groups : [];
      },
      getHasGlobalGroup: function getHasGlobalGroup(id) {
        return !_.isUndefined(_.find(self.getGroups(id), function (g) {
          return g.id === -1;
        }));
      },
      save: function save(id, permissions, people, groups) {
        var entityParams = {
          value: 'badge',
          entityId: id
        };
        return AppPermissions.multiSave(permissions, {
          params: entityParams
        }).then(function saveBadgePermissionsSuccess() {
          return self.set(id, permissions, people, groups);
        }, function saveBadgePermissionsError(response) {
          Logger.error("Error updating badge permissions, response status " + response.status);
          return {};
        });
      },
      set: function set(id, permissions, people, groups) {
        if (!_.has(self.__permissionMap, id)) {
          if (!self.__permissionMap) {
            self.__permissionMap = {};
          }
          self.__permissionMap[id] = {
            permissions: [],
            people: [],
            groups: []
          };
        }
        var entityPermissions = self.__permissionMap[id];
        if (_.isArray(permissions)) {
          entityPermissions.permissions = permissions;
        }
        if (_.isArray(people)) {
          entityPermissions.people = _.sortBy(people, 'name');
        }
        if (_.isArray(groups)) {
          entityPermissions.groups = _.sortBy(groups, 'name');
        }
        return entityPermissions;
      },
      // todo: does removing badge also remove its appPermissions?
      remove: function remove(id) {
        delete self.__permissionMap[id];
      },
      updateBadges: function updateBadges() {
        Badges.update();
        return self.fetch();
      }
    };
    return self;
  }]).config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/settings/badges', {
      templateUrl: 'modules/app/settings/integrations/credly/badges/badges-settings.html',
      controller: 'BadgeSettingsCtrl',
      requiredPermissions: ['admin', 'manager']
    }).when('/settings/badges/:badgeId', {
      templateUrl: 'modules/app/settings/integrations/credly/badges/badges-editor.html',
      controller: 'BadgeEditorCtrl',
      requiredPermissions: ['admin', 'manager']
    });
  }]).controller('BadgeSettingsCtrl', ['$scope', 'UserRoles', 'User', function ($scope, UserRoles, User) {
    $scope.section = "badges";
    $scope.isAreaAdmin = UserRoles.isOrgAdmin(User.get());
  }]).controller('BadgeListCtrl', ["$scope", 'Badges', '$location', 'ConfirmModal', '$http', 'Api', '$q', 'wsEventNames', 'BadgePermissionSvc', function ($scope, Badges, $location, ConfirmModal, $http, Api, $q, wsEventNames, BadgePermissionSvc) {
    $scope.$emit("headline:change", "Settings");
    $scope.$emit("nav:change", "settings");
    $scope.section = "badges";
    $scope.badges = [];
    $scope.sortControls = [{
      "title": "Badge",
      "options": {
        "Name Ascending": "name",
        "Name Descending": "-name"
      }
    }, {
      "title": "Awarded Count",
      "options": {
        "Last Updated Ascending": "awarded",
        "Last Updated Descending": "-awarded"
      }
    }, {
      "title": "Updated",
      "options": {
        "Last Updated Ascending": "updated",
        "Last Updated Descending": "-updated"
      }
    }];
    $scope.sortBy = "name";
    $scope.defaultSortBy = "name";
    $scope.useLegacySearchParams = true;
    $scope.editing = {
      "badgeName": false
    };
    $scope.deleteBadge = function deleteBadge(badge) {
      var body;
      var confirmBtn;
      if (badge.reportCount) {
        body = "This will remove this badge from the ".concat(badge.reportCount, " report").concat(badge.reportCount > 1 ? 's' : '', " it is used on. Are you sure?");
        confirmBtn = "Delete and remove from reports";
      } else {
        body = "Are you sure?";
        confirmBtn = "Delete";
      }
      var deleteModal = {
        title: "Delete Custom badge " + badge.name,
        body: body,
        cancelBtn: "Cancel",
        confirmBtn: confirmBtn,
        confirm: function confirm() {
          $http.delete(Api.url("/badges/v2/" + badge.id)).then(function () {
            //refresh UI
            $scope.setBadgePage(0);
          });
        },
        cancel: function cancel() {}
      };
      ConfirmModal.open($scope, deleteModal);
    };
    $scope.isLoading = false;
    $scope.fetchData = function fetchData(params) {
      $scope.isLoading = true;
      var defer = $q.defer();
      var _params = Object.assign({}, params, {
        searchText: params.searchTerm || ""
      });
      return BadgePermissionSvc.fetch(_params).then(function (results) {
        $scope.isLoading = false;
        $scope.badges = results.badges;
        return defer.promise;
      });
    };
    $scope.fetchBadgePage = function (offset, limit) {
      $scope.isLoading = true;
      var params = {
        _limit: limit,
        _offset: offset,
        searchText: $scope.search.name
      };
      var defer = $q.defer();
      return BadgePermissionSvc.fetch(params).then(function (results) {
        $scope.isLoading = false;
        $scope.badges = results.badges;
        return defer.promise;
      });
    };
    var prevSearchTerm = '';
    $scope.updateSearchTerm = function updateSearchTerm() {
      if ($scope.searchTerm !== prevSearchTerm) {
        $scope.$broadcast(wsEventNames.pager.setPage, 1);
        prevSearchTerm = $scope.searchTerm;
      }
    };
    $scope.setBadgePage = function setBadgePage() {
      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      $scope.$broadcast(wsEventNames.pager.setPage, p);
    };
    $scope.formatPermissionsDisplay = function (d) {
      if (d.hasGlobalGroup) {
        return "All groups and people";
      } else {
        var groupDisplay, peopleDisplay;
        if (d.groups && d.groups.length > 0) {
          groupDisplay = d.groups.length + " group" + (d.groups.length > 1 ? "s" : "");
        }
        if (d.people && d.people.length > 0) {
          peopleDisplay = d.people.length + (d.people.length > 1 ? " people" : " person");
        }
        if (groupDisplay && peopleDisplay) {
          return groupDisplay + ", " + peopleDisplay;
        } else {
          if (groupDisplay) {
            return groupDisplay;
          } else {
            return peopleDisplay;
          }
        }
      }
    };
  }]).controller('BadgeEditorCtrl', ['$scope', '$routeParams', 'Api', '$http', '$q', '$timeout', 'ConfirmModal', '$location', 'People', 'Groups', 'GroupTypes', 'CardQueryResource', 'AggregationUtils', 'BadgeUtils', 'BadgeRegistry', 'BadgePermissionSvc', 'Activities', 'CardRegistry', 'Utils', function ($scope, $routeParams, Api, $http, $q, $timeout, ConfirmModal, $location, People, Groups, GroupTypes, CardQueryResource, AggUtils, BadgeUtils, BadgeRegistry, PermissionSvc, Activities, CardRegistry, Utils) {
    $scope.advancedConfig = false;
    $scope.peoplePickerConfig = $scope.peoplePickerConfig || {
      selectedPeopleOrGroups: [],
      excludedPeopleOrGroups: [],
      intersectGroups: false,
      intersectExcludedGroups: false,
      pickerConfig: $scope.pickerConfig,
      personPicker: $scope.personPicker,
      hideListPicker: true,
      hideDynamicUser: true,
      scope: $scope
    };
    var badgeId = $routeParams.badgeId;
    $scope.originalBadge = {};
    $scope.issuerEarnerId = "";
    $scope.issuerEarnerIdValues = [{
      label: "",
      value: ""
    }, {
      label: "Custom ID",
      value: "customId"
    }];

    // Default before we fetch the actual badge
    $scope.badge = {
      "name": "",
      "dimension": "",
      "config": {
        "peopleFilter": {},
        "criteria": [],
        "awardNewVersion": false,
        "issuerEarnerId": ""
      }
    };
    $scope.badgeChanged = false;
    $scope.initializedBadgeEditor = false;
    BadgeUtils.clearCachedPromises();

    /* Filters */
    var _setFilters = function setFilters(val, key, obj, not) {
      if (key === 'not') {
        _.each(val, function (val, key) {
          _setFilters(val, key, null, true);
        });
      } else if (key === "equals") {
        _.each(val, function (v) {
          var combinedIds = "";
          _.each(v.values.ids, function (id) {
            combinedIds += id + ',';
          });
          combinedIds = combinedIds.slice(0, -1); //remove last comma

          var filterKey = _.findWhere($scope.filterKeys, {
            id: "equals"
          });
          $scope.filters.push({
            key: filterKey,
            equalsField: v.fieldName,
            equalsFieldType: v.fieldType,
            value: combinedIds,
            regExp: v.values && v.values.regExp,
            not: not
          });
        });
      } else if (_.pluck($scope.filterKeys, 'id').indexOf(key) !== -1) {
        var ids = val.ids ? val.ids : val;
        _.each(ids, function (id) {
          var filterKey = _.findWhere($scope.filterKeys, {
            id: key
          }) || {
            id: key,
            name: key
          };
          $scope.filters.push({
            key: filterKey,
            value: {
              id: id,
              name: id
            },
            regExp: val.regExp,
            not: not
          });
        });
      } else {
        $scope.advancedFilters[key] = val;
      }
    };
    var updateFilters = function updateFilters(pFilter) {
      var filter = {};

      // If a filter is passed in from ace editor, we want to populate client side filters from it
      // Also check against arrays as the debounce for updated filters in UI passes an array object in
      if (!_.isNull(pFilter) && !_.isUndefined(pFilter) && !Array.isArray(pFilter) && Object.keys(pFilter.length !== 0)) {
        $scope.filters = [];
        _.each($scope.badge.config.criteria, _setFilters);
      }
      _.each($scope.filters, function (f) {
        if (f.not && !filter.hasOwnProperty('not')) {
          filter.not = {};
        }
        var property = f.not ? filter.not : filter,
          key = f.key.id;

        //does this property need an IdList object?
        var isIdList = _.contains(["activityIds", "verbIds", "parentActivityIds", "groupingActivityIds", "contextActivityIds"], key);

        //add property if it doesn't exists
        if (!property.hasOwnProperty(key)) {
          if (isIdList) {
            property[key] = {
              "ids": [],
              "regExp": f.regExp
            };
          } else {
            property[key] = [];
          }
        }
        if (key === "equals") {
          if (!f.value) {
            return;
          }
          if (_.isEmpty(property.equals)) {
            property.equals = [];
          }
          if (_typeof(f.value) !== "object") {
            var ids = f.value.split(",");
            // Special case, avoid splitting on commas for object descriptions
            if (f.equalsField && f.equalsField.includes("object.definition.description")) {
              ids = [f.value];
            }
            property.equals.push({
              fieldName: f.equalsField,
              fieldType: f.equalsFieldType,
              values: {
                ids: ids.map(function (id) {
                  return id.trim();
                }),
                regExp: f.regExp
              }
            });
          }
          return;
        } else {
          //get the list so we can add the value to it
          if (isIdList) {
            property = property[key].ids;
          } else {
            property = property[key];
          }
        }
        if (!f.value) {
          return;
        }
        if (!_.isUndefined(f.value.id)) {
          property.push(f.value.id);
        } else {
          property.push(f.value);
        }
      });
      _.each($scope.advancedFilters, function (val, key) {
        filter[key] = val;
      });
    };
    $scope.updateIssuerEarnerId = function updateIssuerEarnerId() {
      $scope.badge.config.issuerEarnerId = $scope.issuerEarnerId.value;
    };
    $scope.filters = [];
    $scope.advancedFilters = {};
    $scope.filterKeys = [{
      "id": "activityIds",
      "name": "Activity"
    }, {
      "id": "verbIds",
      "name": "Verb"
    }, {
      "id": "personIds",
      "name": "Person"
    }, {
      "id": "groupIds",
      "name": "Group"
    }, {
      "id": "equals",
      "name": "Other"
    }];

    // Create a "none" category with a value of null
    $scope.noneCategory = {
      name: "None",
      id: null
    };

    // TODO: unsure if we'll want categories for badges... ignoring for now
    var initCategories = function initCategories() {
      // $http.get(Api.url("/badge-categories")).then(
      //     function(r) {
      //         $scope.categories = r.data.results;
      //         $scope.categories.unshift($scope.noneCategory);
      //
      //         // attach category
      //         if ($scope.badge.badgeCategoryName) {
      //             $scope.badge.badgeCategory = _.findWhere($scope.categories, {name: $scope.badge.badgeCategoryName});
      //         } else {
      //             $scope.badge.badgeCategory = $scope.noneCategory;
      //         }
      //     }
      // );
    };
    var editPeople = [];
    var editGroups = [];
    var editPermissions = [];
    $scope.editPeopleAndGroups = [];
    if (badgeId !== "new" && _.isFinite(badgeId)) {
      $http.get(Api.url("/badges/v2/" + badgeId), {
        params: {}
      }).then(function (r) {
        $scope.badge = r.data;
        $scope.originalEntity = angular.copy(r.data);
        $scope.originalName = $scope.badge.name;
        _.each($scope.badge.config.peopleFilter, _setFilters);
        $scope.issuerEarnerId = $scope.issuerEarnerIdValues[0];
        if ($scope.badge.config.issuerEarnerId) {
          $scope.issuerEarnerIdValues.every(function (item) {
            if (item.value === $scope.badge.config.issuerEarnerId) {
              $scope.issuerEarnerId = item;
              return false; // break iteration
            }
            return true; //every requires a truthy return in order to continue iteration
          });
        }
        PermissionSvc.fetchPermissions().then(function getPermissionsSuccess() {
          $scope.badge.permissions = PermissionSvc.get(badgeId);
          editPeople = _.clone($scope.badge.permissions.people);
          editGroups = _.clone($scope.badge.permissions.groups);
          editPermissions = _.clone($scope.badge.permissions.permissions);
          $scope.editPeopleAndGroups = [].concat(editPeople, editGroups);
        });
        $scope.originalBadge = angular.copy($scope.originalEntity);
        initCategories();

        // Set up our people and group picker on page load
        initSimpleModeScope($scope.badge.config.peopleFilter, $scope.peoplePickerConfig);
      });
    } else {
      var copyBadge = $routeParams.copy;
      if (copyBadge) {
        if (_.isFinite(copyBadge)) {
          $http.get(Api.url("/badges/v2/" + copyBadge)).then(function (r) {
            $scope.badge = r.data;
            delete $scope.badge.id;
            delete $scope.badge.created;
            delete $scope.badge.updated;
            $scope.badge.name = 'Copy of ' + $scope.badge.name;
            _.each($scope.badge.config.peopleFilter, _setFilters);
          });
        } else {
          copyBadge = JSON.parse(copyBadge);
          $scope.badge.name = 'Copy of ' + copyBadge.name;
          $scope.badge.visibility = 'everyone';
          $scope.badge.config = copyBadge;
          _.each($scope.badge.config.peopleFilter, _setFilters);
        }
      } else {
        $scope.badge = {
          "name": "",
          "dimension": "",
          "config": {
            "peopleFilter": {},
            "criteria": [],
            "awardNewVersion": false,
            "issuerEarnerId": ""
          }
        };
      }
      $scope.originalBadge = angular.copy($scope.badge);
      initCategories();

      // Set up our people and group picker on page load
      initSimpleModeScope($scope.badge.config.peopleFilter, $scope.peoplePickerConfig);
    }

    // currently just keeps sending requests EVERY time typing is done
    $scope.selectedBadge = {};
    $scope.badgeTemplates = [];
    $scope.getBadgeTemplateTypeahead = function (text) {
      return $http.get(Api.url('/badges/v2/templates'), {
        params: {
          searchTerm: text,
          page: 0
        }
      }).then(function (r) {
        $scope.badgeTemplates = _.map(r.data.data, function (d) {
          return {
            id: d.id,
            name: d.name
          };
        });
        return $scope.badgeTemplates;
      });
    };
    $scope.selectBadgeTemplate = function (item) {
      $scope.selectedBadge = item;
      $scope.badge.name = $scope.selectedBadge.name;
      $scope.badge.credlyBadgeId = $scope.selectedBadge.id;
    };
    $scope.getCompletedStatus = function (item) {
      var completedAllActivities = true;
      item.aggregations.forEach(function (agg) {
        if (agg.value < 1) {
          completedAllActivities = false;
        }
      });
      return completedAllActivities ? "completed" : "not completed";
    };
    $scope.getFilterTypeahead = function (key, val) {
      if (!key || !key.id) {
        return [];
      }

      //TODO: implement searching for people, groups and activities by other fields (ids, descriptions etc)
      switch (key.id) {
        case "verbIds":
          return $http.get(Api.url('/acc/verbs'), {
            params: {
              in_display: val,
              order_by: "display",
              _limit: 10
            }
          }).then(function (r) {
            return _.map(r.data.results, function (d) {
              return {
                id: d.verbId,
                name: d.display
              };
            });
          });
        case "activityIds":
          return $http.get(Api.url('/acc/activities'), {
            params: {
              in_name: val,
              order_by: "name",
              _limit: 10
            }
          }).then(function (r) {
            return _.map(r.data.results, function (d) {
              return {
                id: d.activityId,
                name: d.name
              };
            });
          });
        case "personIds":
          return $http.get(Api.url('people'), {
            params: {
              "in_name": val,
              "order_by": "name",
              "_limit": 10
            }
          }).then(function (r) {
            return r.data.results;
          });
        case "groupIds":
          return $http.get(Api.url("/groups"), {
            params: {
              "in_name": val,
              "order_by": "name",
              "_limit": 10
            }
          }).then(function (r) {
            return r.data.results;
          });
        default:
          //equals filter
          return [];
      }
    };
    $scope.getViewForVerb = function (verb) {
      if (!_.isUndefined(verb) && !_.isNull(verb)) {
        var verbComponents = verb.toString().split("/");
        return verbComponents[verbComponents.length - 1];
      }
      return "";
    };

    /* Value producer TODO: these are only necessary if we integrate some of the measure logic per criteria */

    $scope.valueProducers = [{
      id: 'STATEMENT_PROPERTY',
      name: 'Statement property'
    }, {
      id: 'TIME',
      name: 'Time period'
    }];
    $scope.dimensionStatementProperties = ["actor.person.id", "actors.person.id"];
    $scope.valueProducerStatementProperties = ["id", "actor.objectType", "actors.person.id", "actors.groups.id", "actor.name", "actor.mbox", "actor.mbox_sha1sum", "actor.openid", "actor.account.name", "actor.account.homePage", "verb.id", "verb.display", "verb.name", "object.id", "object.objectType", "object.definition.name", "object.definition.description", "object.definition.type", "object.definition.moreInfo", "object.definition.interactionType", "object.definition.correctResponsesPattern", "object.definition.choices", "object.definition.scale", "object.definition.source", "object.definition.target", "object.definition.steps", "object.definition.extensions", "object.name", "object.mbox", "object.mbox_sha1sum", "object.openid", "object.account.name", "object.account.homePage", "object.result", "object.context", "object.timestamp", "result.success", "result.completion", "result.response", "result.duration", "result.durationCentiseconds", "result.score.raw", "result.score.scaled", "result.score.min", "result.score.max", "result.extensions", "context.registration", "context.instructor", "context.team", "context.revision", "context.platform", "context.language", "context.statement", "context.contextActivities.parent.id", "context.contextActivities.grouping.id", "context.contextActivities.other.id", "context.extensions", "timestamp", "stored", "authority.name", "version"];
    $scope.valueProducerTimePeriods = ['DAY', 'WEEK', 'MONTH', 'YEAR'];

    /* Aggregation */

    $scope.aggregations = [{
      id: 'COUNT',
      name: 'Count',
      description: 'Counts the number of occurrences of the chosen value above.'
    }, {
      id: 'DISTINCT_COUNT',
      name: 'Distinct count',
      description: 'Counts the number of unique occurrences of the chosen value above.'
    }, {
      id: 'SUM',
      name: 'Sum',
      description: 'Adds all the values together'
    }, {
      id: 'AVERAGE',
      name: 'Average',
      description: 'Adds all the values together then divides by the number of occurrences.'
    }, {
      id: 'FIRST',
      name: 'First',
      description: 'Returns the first value in chronological order.'
    }, {
      id: 'LAST',
      name: 'Last',
      description: 'Returns the last value in chronological order.'
    }, {
      id: 'MIN',
      name: 'Minimum',
      description: 'Returns the minimum value.'
    }, {
      id: 'MAX',
      name: 'Maximum',
      description: 'Returns the maximum value.'
    }, {
      id: 'LIST',
      name: 'List',
      description: 'Returns all the values.'
    }, {
      id: 'SET',
      name: 'Set',
      description: 'Returns all the unique values.'
    }];
    $scope.getAggregationDescription = function (type) {
      if (!type) {
        return null;
      }
      var agg = _.findWhere($scope.aggregations, {
        id: type
      });
      if (!agg) {
        return null;
      }
      return agg.description;
    };

    /* Visibility */

    $scope.visibilities = [{
      id: "everyone",
      name: 'Everyone with Permission'
    }, {
      id: 'none',
      name: 'Hidden'
    }];

    /*  Advances editor */

    var setEditor = function setEditor() {
      // Remove badgeCategory & permissions because they can easily get too large and
      // aren't the primary focus of the advanced badge editor anyway.
      var modifiedEditorBadge = angular.copy($scope.badge);
      delete modifiedEditorBadge.badgeCategory;
      delete modifiedEditorBadge.permissions;
      $scope.editor.setValue(angular.toJson(modifiedEditorBadge, 2), -1);
    };
    $scope.showAdvanced = function () {
      $scope.advancedConfig = true;
      setEditor();
    };
    $scope.showSimple = function () {
      $scope.advancedConfig = false;
    };
    $scope.aceLoaded = function (_editor) {
      $scope.editor = _editor;
      var session = _editor.getSession();
      session.setMode("ace/mode/json");
      session.setTabSize(2);
      session.setUseSoftTabs(true);
    };
    $scope.aceChanged = _.debounce($scope.$safeApply.bind($scope, function () {
      updateBadgeFromAceEditor();
    }), 2000);
    function updateBadgeFromAceEditor() {
      try {
        // Append the badgeCategory and permissions that we removed in
        // the setEditor() function so we don't lose that data.
        var editorBadge = JSON.parse($scope.editor.getValue());
        editorBadge.badgeCategory = $scope.badge.badgeCategory;
        editorBadge.permissions = $scope.badge.permissions;
        $scope.badge = editorBadge;
        if ($scope.advancedConfig && Object.keys($scope.editor.getSession().getAnnotations()).length === 0) {
          updateFilters($scope.badge.config.criteria);
        }
      } catch (e) {
        if (e.name === 'SyntaxError') {
          return; // Disregard
        } else {
          throw e;
        }
      }
    }

    /* Preview TODO: review if necessary */
    $scope.$watch('filters', _.debounce(updateFilters, 1000), true);
    $scope.$watch('badge.config', _.debounce(function (newVal) {
      updatePreview();
      $scope.badgeChanged = !_.isEqual($scope.originalBadge.config, newVal);
    }, 1000), true);
    $scope.$watch('badge.dimension', _.debounce(function (oldValue, newValue) {
      if (oldValue !== newValue) {
        updatePreview();
      }
    }, 1000), true);
    var updatePreview = function updatePreview() {
      var config = $scope.badge.config;
      if (_.isEmpty(config) || _.isEmpty(config.criteria)) {
        return;
      }
      $scope.initializedBadgeEditor = true;
      CardQueryResource.getWithProgress({
        path: "/badges/v2/preview",
        params: {
          badge: JSON.stringify($scope.badge),
          _limit: 5
        },
        progressChannel: 'preview-badge'
      }).then(function (r) {
        $scope.previewResponse = r.results[0].result.data;
      });
    };
    updatePreview();

    /* Save and validation */
    $scope.$watch('badge', _.debounce(function (newValue) {
      //disable the save button until the badge is changed
      if ($scope.initializedBadgeEditor && !_.isEqual($scope.originalBadge, newValue)) {
        $scope.badgeChanged = true;
      }
    }, 100), true);
    var openSaveModal = function openSaveModal() {
      var id = $scope.badge.id,
        bodyText = "";
      if (id) {
        bodyText = "Are you sure?";
      } else {
        bodyText = "This will create a new badge. Are you sure?";
      }
      var modal = {
        title: "Save badge: " + $scope.badge.name,
        body: bodyText,
        cancelBtn: "Cancel",
        confirmBtn: "Save",
        confirm: function confirm() {
          $scope.badgeId = id;
          delete $scope.badge.id;
          delete $scope.badge.uuid;
          (id ? $http.put : $http.post)(Api.url('/badges/v2' + (id ? '/' + id : '')), $scope.badge).then(function (r) {
            if (r.status !== 204) {
              $scope.badge = r.data;
            } else {
              $scope.badge.id = $scope.badgeId;
            }
            BadgeRegistry.add($scope.badge);

            // if no permission changes, all done
            if ($scope.permissionsChanged || !id) {
              _.forEach(editPermissions, function (p) {
                if (_.isUndefined(p.entityId)) {
                  p.entityId = $scope.badge.id;
                }
              });
              PermissionSvc.save($scope.badge.id, editPermissions, editPeople, editGroups).then(function savePermissionsSuccess(permissions) {
                $scope.badge.permissions = permissions;
              });
            }

            // Clear the card registry so users don't have to refresh the page
            // in order to see their badge changes affect their reports.
            CardRegistry.clear();
            $location.path("/settings/badges");
          }, function (e) {
            $scope.error = e.message;
          });
        },
        cancel: function cancel() {}
      };

      // Don't prompt for confirmation if ONLY the category changed
      if ($scope.originalEntity) {
        var originalWithoutCategory = _.clone($scope.originalEntity);
        delete originalWithoutCategory.badgeCategory;
        delete originalWithoutCategory.badgeCategoryName;
        delete originalWithoutCategory.permissions;
        var updateWithoutCategory = _.clone($scope.badge);
        delete updateWithoutCategory.badgeCategory;
        delete updateWithoutCategory.badgeCategoryName;
        delete updateWithoutCategory.permissions;
        var onlyCategoryChanged = !$scope.permissionsChanged && $scope.originalEntity.badgeCategory !== $scope.badge.badgeCategory && angular.equals(originalWithoutCategory, updateWithoutCategory);
        if (onlyCategoryChanged) {
          modal.confirm();
        } else {
          ConfirmModal.open($scope, modal);
        }
      } else {
        ConfirmModal.open($scope, modal);
      }
    };
    var validate = function validate() {
      var error = "";
      if (!$scope.badge.credlyBadgeId) {
        error += "Please specify a Template for this badge by selecting one from the dropdown when searching.";
      }
      if ($scope.badge.config.criteria.length < 1) {
        error += "\nPlease add criteria to the badge. ";
      }
      // if ($scope.badge.dimension === "") {
      //     error += "\nPlease select a valid dimension. "
      // }

      if (error || !$scope.badgeChanged) {
        $scope.error = error;
        return false;
      } else {
        $scope.error = "";
        return true;
      }
    };
    $scope.save = function () {
      updateFilters();
      // Make sure that if they click "save" before the debounced "aceChanged" function
      // is called, that we still update the badge before checking & saving
      // updateBadgeFromAceEditor();
      if (validate()) {
        openSaveModal();
      }
    };
    $scope.addPermission = function addPermission(target) {
      var newPermission = {
        value: 'badge',
        entityId: $scope.badge.id
      };
      if (_.has(target, 'childGroupIds')) {
        editGroups.push(target);
        editPermissions.push(_.extend(newPermission, {
          groupId: target.id
        }));
      } else {
        editPeople.push(target);
        editPermissions.push(_.extend(newPermission, {
          personId: target.id
        }));
      }
      $scope.editPeopleAndGroups = [].concat(editPeople, editGroups);
      $scope.permissionsChanged = havePermissionsChanged();
      $scope.badgeChanged = true;
    };
    $scope.removePermission = function removePermission(target) {
      if (_.has(target, 'childGroupIds')) {
        editGroups = _.reject(editGroups, function (o) {
          return o.id === target.id;
        });
        editPermissions = _.reject(editPermissions, function (p) {
          return p.groupId === target.id;
        });
      } else {
        editPeople = _.reject(editPeople, function (o) {
          return o.id === target.id;
        });
        editPermissions = _.reject(editPermissions, function (p) {
          return p.personId === target.id;
        });
      }
      $scope.editPeopleAndGroups = [].concat(editPeople, editGroups);
      $scope.permissionsChanged = havePermissionsChanged();
      $scope.badgeChanged = true;
    };

    // TODO: this may be useful if we do a similar thing like with measures where we limit who can see what,
    //  but for the moment this interferes with editing an individual badge and would need to be broken out
    //  from that workflow
    // $scope.editPeopleAndGroups is not updated prior to Add or Remove actions,
    // so we check for changes by comparing the ids in people and group arrays directly
    var havePermissionsChanged = function havePermissionsChanged() {
      // var id = $scope.badge.id;
      // return !_.isEqual(_.pluck(PermissionSvc.getGroups(id), 'id'), _.pluck(editGroups, 'id')) ||
      //     !_.isEqual(_.pluck(PermissionSvc.getPeople(id), 'id'), _.pluck(editPeople, 'id'));
    };
    if (!$scope.customConfig) {
      $scope.customConfig = {};
    }
    if (!$scope.customConfig.dialogView) {
      $scope.customConfig.dialogView = [];
    }
    if (_.isUndefined($scope.badge)) {
      $scope.badge = {
        "name": "",
        "dimension": "",
        "config": {
          "peopleFilter": {},
          "criteria": [],
          "awardNewVersion": false,
          "issuerEarnerId": ""
        }
      };
    }

    // Controlling this disabled flag explicitly because of the oddity of having the edit/delete
    // buttons within the draggable list item -- when hovering/clicking these actions we don't want to
    // be able to drag the items -- this was preventing the edit/delete actions from triggering sometimes.
    $scope.sortableOptions = {
      disabled: false
    };
    $scope.dialog = {
      show: false
    };

    // Picker stuff
    $scope.pickerActions = {
      activityPicker: $scope.activityPickerConfig,
      verbPicker: $scope.verbPickerConfig,
      peoplePicker: $scope.peoplePickerConfig
    };
    $scope.pickerConfig = {
      dialogHeight: $scope.dialogHeight,
      dialogChoice: $scope.dialogChoice,
      dialog: $scope.dialog
    };
    $scope.toggleSection = function toggleSection(section) {
      $scope.openSection = $scope.openSection === section ? null : section;
    };
    $scope.dialogChoice = {
      picker: false,
      toAdvanced: false,
      toSimple: false,
      pickerLoading: false,
      isCustom: false
    };
    var cleanupDialogWatch = $scope.$watch("dialogChoice", function () {
      $scope.dialogHeight = $(".badge-main").height();
      $scope.pickerConfig.dialogHeight = $scope.dialogHeight;
    }, true);
    $scope.openDialog = function openDialog(type, isCustom) {
      $scope.dialog.show = true;
      $scope.dialogChoice = {
        picker: false,
        toAdvanced: false,
        toSimple: false,
        pickerLoading: false,
        isCustom: isCustom
      };
      $scope.pickerConfig.dialogChoice = $scope.dialogChoice;

      // set the dialogChoice option, then resolve dialogChoice.customConfig
      $scope.dialogChoice[type] = true;
      if (type.toLowerCase().indexOf("picker") !== -1) {
        $scope.dialogChoice.picker = true;
        if ($scope.pickerActions[type]) {
          $scope.dialogChoice.pickerLoading = null;
          $timeout(function () {
            if ($scope.dialogChoice.pickerLoading === null) {
              $scope.dialogChoice.pickerLoading = true;
            }
          }, 1000);
          $scope.pickerActions[type].buildPicker();
        }
      }
    };
    $scope.pickerConfig.openDialog = $scope.openDialog;
    function initSimpleModeScope(filter, peoplePickerConfig) {
      var immutable = peoplePickerConfig.immutable || false,
        excludedPeopleOrGroupsFilter;
      if (filter.not && filter.not.or) {
        excludedPeopleOrGroupsFilter = _.find(filter.not.or, function (f) {
          return f.personIds || f.personCustomIds || f.groupIds || f.groupCustomIds || f.groupTypeNames;
        });
      }
      if (filter.personIds || filter.personCustomIds || filter.groupIds || filter.groupCustomIds || filter.groupTypeNames || excludedPeopleOrGroupsFilter || filter.excludeInactivePeople || Utils._try(function () {
        return filter.or[0].groupIds;
      }, false)) {
        peoplePickerConfig.excludeInactivePeople = filter.excludeInactivePeople;
        var personFetchCfg = {
          params: {
            customIds: (filter.personCustomIds || []).concat(excludedPeopleOrGroupsFilter ? excludedPeopleOrGroupsFilter.personCustomIds || [] : []),
            "_limit": 1000
          }
        };
        var groupFetchCfg = {
          params: {
            customIds: (filter.groupCustomIds || []).concat(excludedPeopleOrGroupsFilter ? excludedPeopleOrGroupsFilter.groupCustomIds || [] : []),
            "_limit": 1000
          }
        };
        var peopleUrl = People.multiGet((filter.personIds || []).concat(excludedPeopleOrGroupsFilter ? excludedPeopleOrGroupsFilter.personIds || [] : []), personFetchCfg);
        var groupIds = filter.groupIds || [];
        if (filter.or && filter.or.length > 0 && filter.or[0].excludeFromOutput && filter.or[0].groupIds) {
          groupIds = groupIds.concat(filter.or[0].groupIds);
        }
        if (filter.or && filter.or.length > 1 && filter.or[1].groupIds) {
          groupIds = groupIds.concat(filter.or[1].groupIds);
        }
        if (excludedPeopleOrGroupsFilter) {
          groupIds = groupIds.concat(excludedPeopleOrGroupsFilter.groupIds || []);
        }
        var groupUrl = Groups.multiGet(groupIds, groupFetchCfg);
        return $q.all([peopleUrl, groupUrl]).then(function (responses) {
          _.each(filter.personIds, function (value) {
            var person = _.findWhere(responses[0].results, {
              id: value
            });
            if (person) {
              peoplePickerConfig.personOrGroupSelected(person, immutable);
            }
          });
          _.each(filter.personCustomIds, function (value) {
            var person = _.findWhere(responses[0].results, {
              customId: value
            });
            if (person) {
              peoplePickerConfig.personOrGroupSelected(person, immutable);
            }
          });
          _.each(filter.groupIds, function (value) {
            var group = _.findWhere(responses[1].results, {
              id: value
            });
            if (group) {
              peoplePickerConfig.personOrGroupSelected(group, immutable);
            }
          });
          _.each(filter.groupCustomIds, function (value) {
            var group = _.findWhere(responses[1].results, {
              customId: value
            });
            if (group) {
              peoplePickerConfig.personOrGroupSelected(group, immutable);
            }
          });
          peoplePickerConfig.intersectGroups = filter.intersectGroups;
          if (filter.or && filter.or.length > 0 && filter.or[0].excludeFromOutput) {
            _.each(filter.or[0].groupIds, function (value) {
              var group = _.findWhere(responses[1].results, {
                id: value
              });
              group.excludeFromOutput = true;
              if (group) {
                peoplePickerConfig.personOrGroupSelected(group, immutable);
              }
            });
          }
          if (filter.or && filter.or.length > 1 && filter.or[1].groupIds) {
            _.each(filter.or[1].groupIds, function (value) {
              var group = _.findWhere(responses[1].results, {
                id: value
              });
              if (group) {
                peoplePickerConfig.personOrGroupSelected(group, immutable);
              }
            });
          }
          if (filter.groupTypeNames && filter.groupTypeNames.length) {
            // We're expecting that we've already called group-types once
            // and cached the results when we started Report Builder
            var groupTypes = GroupTypes.getCache();
            if (groupTypes.length) {
              filter.groupTypeNames = filter.groupTypeNames.map(function (name) {
                var match = groupTypes.filter(function (g) {
                  return g.name === name;
                });
                if (match.length) {
                  return match[0];
                } else {
                  return {
                    name: name
                  };
                }
              });
            } else {
              filter.groupTypeNames = filter.groupTypeNames.map(function (n) {
                return {
                  name: n
                };
              });
            }
            _.each(filter.groupTypeNames, function (value) {
              peoplePickerConfig.personOrGroupSelected(value, immutable);
            });
          }
          if (excludedPeopleOrGroupsFilter) {
            _.each(excludedPeopleOrGroupsFilter.personIds, function (value) {
              var person = _.findWhere(responses[0].results, {
                id: value
              });
              if (person) {
                peoplePickerConfig.excludePersonOrGroup(person, immutable);
              }
            });
            _.each(excludedPeopleOrGroupsFilter.personCustomIds, function (value) {
              var person = _.findWhere(responses[0].results, {
                customId: value
              });
              if (person) {
                peoplePickerConfig.excludePersonOrGroup(person, immutable);
              }
            });
            _.each(excludedPeopleOrGroupsFilter.groupIds, function (value) {
              var group = _.findWhere(responses[1].results, {
                id: value
              });
              if (group) {
                peoplePickerConfig.excludePersonOrGroup(group, immutable);
              }
            });
            _.each(excludedPeopleOrGroupsFilter.groupCustomIds, function (value) {
              var group = _.findWhere(responses[1].results, {
                customId: value
              });
              if (group) {
                peoplePickerConfig.excludePersonOrGroup(group, immutable);
              }
            });
            _.each(excludedPeopleOrGroupsFilter.groupTypeNames || [], function (value) {
              peoplePickerConfig.excludePersonOrGroup({
                name: value
              }, immutable);
            });
            peoplePickerConfig.intersectExcludedGroups = excludedPeopleOrGroupsFilter.intersectGroups;
          }
        });
      }
    }

    // TODO: revisit if this function is needed at all down the line
    function initCriteria() {
      if (_.isUndefined($scope.badge.config.criteria)) {
        $scope.badge.config.criteria = [];
      }
    }
    function cleanCriteriaFilter(criteria) {
      if (_.isEmpty(criteria.filter.activityIds.ids[0])) {
        delete criteria.filter.activityIds;
      }
      if (_.isEmpty(criteria.filter.verbIds.ids[0])) {
        delete criteria.filter.verbIds;
      }
    }
    function addCriteriaToList(criteria) {
      cleanCriteriaFilter(criteria);
      $scope.badge.config.criteria.push(criteria);
    }
    function isStepCompletionOrdered() {
      var alt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var programExists = typeof $scope.badge !== 'undefined';
      return programExists && !!$scope.badge.ordered || alt;
    }
    $scope.isStepCompletionOrdered = isStepCompletionOrdered;

    // Criteria Editor
    $scope.addCriteria = function addCriteria() {
      $scope.customConfig.selectedActivity = null;
      $scope.customConfig.selectedVerb = null;
      $scope.customConfig.dialogView.push("criteriaEditor");
      delete $scope.validationErrors;
      $scope.customConfig.criteriaToEdit = {
        "name": "",
        "successRequired": false,
        "filter": {
          "activityIds": {
            "ids": [""]
          },
          "verbIds": {
            "ids": [""]
          }
        }
      };
      $scope.customConfig.isNewCriteria = true;

      // openDialog is defined by explorer.js
      $scope.openDialog('criteriaEditor', true);
    };
    $scope.editCriteria = function editCriteria(criteria) {
      var editor = criteria.type === "collection" ? "advancedStepEditor" : "criteriaEditor";
      $scope.customConfig.selectedActivity = null;
      $scope.customConfig.selectedVerb = null;
      $scope.customConfig.dialogView.push(editor);
      if (criteria && criteria.filter && (criteria.filter.activityIds || criteria.filter.verbIds)) {
        $q.all([criteria.filter.activityIds && $scope.getActivityName(criteria.filter.activityIds.ids[0]), criteria.filter.verbIds && $scope.getVerbName(criteria.filter.verbIds.ids[0])]).then(function (r) {
          if (r[0]) {
            $scope.customConfig.selectedActivity = {
              'name': r[0],
              'activityId': criteria.filter.activityIds.ids[0]
            };
          }
          if (r[1]) {
            $scope.customConfig.selectedVerb = r[1];
          }
          if (editor === 'advancedStepEditor') {
            $scope.customConfig.advancedCriteriaToEdit = criteria;
          } else {
            $scope.customConfig.criteriaToEdit = criteria;
          }
          $scope.openDialog(editor, true);
        });
      } else {
        $scope.currentActivityName = "no Name";
        if (editor === 'advancedStepEditor') {
          $scope.customConfig.advancedCriteriaToEdit = criteria;
        } else {
          $scope.customConfig.criteriaToEdit = criteria;
        }
        $scope.openDialog(editor, true);
      }
    };
    $scope.saveCriteria = function saveCriteria() {
      // Validate
      $scope.validationErrors = [];
      if (_.isEmpty($scope.customConfig.criteriaToEdit.name)) {
        $scope.validationErrors.push("Please enter Criteria Name");
      }
      if (_.isEmpty(Utils._try(function () {
        return $scope.customConfig.criteriaToEdit.filter.activityIds.ids[0];
      }, []))) {
        $scope.validationErrors.push("Please select an existing activity");
      }
      if ($scope.validationErrors.length > 0) {
        return false;
      }

      // Let the server-side code reconstruct the id so it's in line with any name changes
      delete $scope.customConfig.criteriaToEdit.id;

      // If it's the first activity, create a criteria
      initCriteria();
      if ($scope.customConfig.isNewCriteria) {
        var criteriaToEdit = angular.copy($scope.customConfig.criteriaToEdit);
        addCriteriaToList(criteriaToEdit);
        $scope.customConfig.isNewCriteria = false;
      }
      $scope.back();
    };
    $scope.deleteCriteria = function deleteCriteria(criteria) {
      var filteredCriteria = _.filter($scope.badge.config.criteria, function (c) {
        return c.name !== criteria.name;
      });
      if (filteredCriteria.length === 0) {
        $scope.badge.config.criteria = [];
      } else {
        $scope.badge.config.criteria = filteredCriteria;
      }
    };
    $scope.back = function back() {
      $scope.customConfig.dialogView.pop();
      if ($scope.customConfig.dialogView.length === 0) {
        //scope.dialog.show is in explorer.js
        $scope.dialog.show = false;
      } else {
        $scope.openDialog($scope.customConfig.dialogView[$scope.customConfig.dialogView.length - 1], true);
      }
    };
    $scope.getActivityName = function getActivityName(activityId) {
      var searchParams = {
        activityIds: [activityId],
        _limit: 1
      };
      return $http.get(Api.url('/acc/activities/multi/by-activity-id'), {
        params: searchParams
      }).then(function activitySearchSuccess(response) {
        if (response.data !== null && response.data.results && response.data.results.length > 0) {
          $scope.errorMsg = null;
          var activity = response.data.results[0];
          if (activity.name) {
            return {
              activityId: activity.activityId,
              name: activity.name || '--'
            };
          } else {
            return {
              activityId: activity.activityId,
              name: activity.activityId
            };
          }
        }
        return {};
      });
    };
    $scope.getVerbName = function getVerbName(verbId) {
      /*jshint camelcase: false */
      var searchParams = {
        searchTerm: verbId,
        order_by: "verbId",
        _limit: 1
      };
      /*jshint camelcase: true */

      return $http.get(Api.url('/acc/verbs/search'), {
        params: searchParams
      }).then(function verbSearchSuccess(response) {
        if (response.data.results.length > 0) {
          return response.data.results[0];
        }
        return {};
      });
    };
    var cleanupPeopleOrGroupsWatch = $scope.$watchCollection('peoplePickerConfig.selectedPeopleOrGroups', function (item) {
      // Drop any null items that might have snuck in
      item = _.filter(item, function (item) {
        return !!item;
      });
      var people = _.filter(item, function (item) {
        return item.personas;
      });
      var personIds = [];
      var personCustomIds = [];
      _.each(people, function (person) {
        if (person.customId) {
          personCustomIds.push(person.customId);
        } else {
          personIds.push(person.id);
        }
      });
      $scope.badge.config.peopleFilter.personIds = Utils.ifEmptyThenNull(personIds);
      $scope.badge.config.peopleFilter.personCustomIds = Utils.ifEmptyThenNull(personCustomIds);
      var groups = _.filter(item, function (item) {
        return item.peopleIds;
      });
      var groupIds = [];
      var groupCustomIds = [];
      var groupIdsExcludedFromOutput = [];
      _.each(groups, function (group) {
        if (group.excludeFromOutput) {
          groupIdsExcludedFromOutput.push(group.id);
        } else if (group.customId) {
          groupCustomIds.push(group.customId);
        } else {
          groupIds.push(group.id);
        }
      });
      $scope.badge.config.peopleFilter.groupCustomIds = Utils.ifEmptyThenNull(groupCustomIds);

      // add/remove groups from filter OR
      if (groupIdsExcludedFromOutput.length > 0) {
        $scope.badge.config.peopleFilter.groupIds = null; // empty groupIds to replace with OR
        $scope.badge.config.peopleFilter.or = [];
        if ($scope.badge.config.peopleFilter.or.length === 0 || !$scope.badge.config.peopleFilter.or[0].excludeFromOutput) {
          $scope.badge.config.peopleFilter.or.unshift({
            excludeFromOutput: true
          });
          $scope.badge.config.peopleFilter.or.push({
            groupIds: groupIds
          });
        }
        $scope.badge.config.peopleFilter.or[0].groupIds = groupIdsExcludedFromOutput;
      } else if ($scope.badge.config.peopleFilter.or && $scope.badge.config.peopleFilter.or[0] && $scope.badge.config.peopleFilter.or[0].excludeFromOutput && $scope.badge.config.peopleFilter.or[0].groupIds) {
        //remove the or filter if all the groups excluded from output are removed
        $scope.badge.config.peopleFilter.or = [];
        $scope.badge.config.peopleFilter.groupIds = Utils.ifEmptyThenNull(groupIds);
      } else {
        $scope.badge.config.peopleFilter.groupIds = Utils.ifEmptyThenNull(groupIds);
      }
      var groupTypes = _.filter(item, function (item) {
        return !item.personas && !item.peopleIds;
      });
      $scope.badge.config.peopleFilter.groupTypeNames = Utils.ifEmptyThenNull(_.pluck(groupTypes, 'name'));
    }, true);
    var cleanupExcludedPeopleOrGroupWatch = $scope.$watchCollection('peoplePickerConfig.excludedPeopleOrGroups', function (item) {
      // Drop any null items that might have snuck in
      item = item.filter(Boolean);

      // Map out personIds & customIds
      var people = item.filter(function (i) {
        return i.personas;
      });
      var personIds = people.filter(function (p) {
        return !p.customId;
      }).map(function (p) {
        return p.id;
      });
      var personCustomIds = people.filter(function (p) {
        return p.customId;
      }).map(function (p) {
        return p.customId;
      });

      // Map out groups, groupIds, and customGroupIds
      var groups = item.filter(function (i) {
        return i.peopleIds;
      });
      var groupIds = groups.filter(function (g) {
        return !g.customId;
      }).map(function (g) {
        return g.id;
      });
      var groupCustomIds = groups.filter(function (g) {
        return g.customId;
      }).map(function (g) {
        return g.customId;
      });

      // Map out group type names
      var groupTypes = item.filter(function (i) {
        return !i.personas && !i.peopleIds;
      }).map(function (g) {
        return g.name;
      });

      // Build the filter based on the maps above
      var filter = {
        personIds: Utils.ifEmptyThenNull(personIds),
        personCustomIds: Utils.ifEmptyThenNull(personCustomIds),
        groupIds: Utils.ifEmptyThenNull(groupIds),
        groupCustomIds: Utils.ifEmptyThenNull(groupCustomIds),
        groupTypeNames: Utils.ifEmptyThenNull(groupTypes)
      };

      // Init the NOT & NOT[OR] filters if they don't exist yet
      $scope.badge.config.peopleFilter.not = $scope.badge.config.peopleFilter.not || {};
      $scope.badge.config.peopleFilter.not.or = $scope.badge.config.peopleFilter.not.or || [];

      // Find the first NOT[OR] filter that has any of the above properties
      var i = _.findIndex($scope.badge.config.peopleFilter.not.or, function (f) {
        var keys = Object.keys(f).join(', ');
        return keys.includes('personIds') || keys.includes('personCustomIds') || keys.includes('groupIds') || keys.includes('groupCustomIds') || keys.includes('groupTypeNames');
      });

      // If there's already a NOT[OR] filter replace it, otherwise, push it
      if (i > -1) {
        $scope.badge.config.peopleFilter.not.or[i] = filter;
      } else {
        $scope.badge.config.peopleFilter.not.or.push(filter);
      }

      // Clean up any filters that are empty or have all null values
      $scope.badge.config.peopleFilter.not.or = cleanupEmptyOrNull($scope.badge.config.peopleFilter.not.or);
    });

    // Clean up any filters that are empty or have all null values
    var cleanupEmptyOrNull = function cleanupEmptyOrNull(filterToCleanup) {
      return filterToCleanup.filter(function (f) {
        var keys = Object.keys(f);
        // If no keys (i.e. empty object) filter it out
        if (!keys) {
          return false;
        }

        // If all null values, filter it out
        var allNullValues = keys.map(function (k) {
          return f[k];
        }).filter(Boolean).length === 0;
        return !allNullValues;
      });
    };
    $scope.$on('$destroy', function () {
      cleanupPeopleOrGroupsWatch();
      cleanupExcludedPeopleOrGroupWatch();
      cleanupDialogWatch();
    });
    $scope.badgeHelpText = {
      helpTitle: 'Badge',
      detailText: 'Define one or more criteria that make up a badge. Each criteria is composed of a matching activity.'
    };
    $scope.competenciesHelpText = {
      helpTitle: 'Competencies',
      detailText: 'Define one or more skills that make up a competency. Each skill correlates to an activity you specify. If these activities report a score result, that score will be used to calculate the competency on a 0.0 - 1.0 scale.'
    };
    $scope.assessmentsHelpText = {
      helpTitle: 'Assessments',
      detailText: 'Configure one more more assessments by selecting the primary activity ID of the assessment you would like to report on. If question data is reported which specifies this activity as the parent activity id, that data will be included as well.'
    };
  }]).controller('BadgePermissionsCtrl', ['$scope', '$controller', '$q', '$http', 'Api', 'BadgePermissionSvc', 'Alerts', 'People', function ($scope, $controller, $q, $http, Api, BadgePermissionSvc, Alerts, People) {
    $scope.searchPlaceholder = "Search for a person or group to see their Badge Permissions";
    $scope.permissionEntitySelected = function (entity) {
      $scope.loading = true;
      // Get the categories and groups for the selected person/group
      var cfg = {
        value: "badge"
      };
      $scope.entityId = entity.id;
      $scope.originalEntity = angular.copy(entity);
      var dataCalls;
      if (entity.personas) {
        cfg.personId = entity.id;
        $scope.isPerson = true;
        dataCalls = $q.all([BadgePermissionSvc.fetch(), People.getPeopleWithMemberships({
          params: {
            id: entity.id
          }
        })]);
      } else {
        cfg.groupId = entity.id;
        $scope.isPerson = false;
        dataCalls = $q.all([BadgePermissionSvc.fetch()]);
      }
      dataCalls.then(function (responses) {
        $scope.badges = responses[0];
        $scope.isOrgAdmin = false;
        if (responses.length > 1) {
          var userWithMemberships = responses[1];
          if (userWithMemberships.count === 1 && userWithMemberships.results[0].membership && userWithMemberships.results[0].membership.role === "admin") {
            $scope.isOrgAdmin = true;
          }
        }
        // Clear out all permission info when cached locally
        _.each($scope.badges, function (d) {
          delete d.hasPermission;
          delete d.directPermission;
        });
        if (!$scope.isOrgAdmin) {
          var url;
          if ($scope.isPerson) {
            url = Api.url("/people/" + $scope.entityId + "/app-permissions?value=badge");
          } else {
            url = Api.url("/groups/" + $scope.entityId + "/app-permissions/include-implicit?value=badge");
          }

          // Decorate the badges objects with permission info from the selected person/group
          $http.get(url).then(function (response) {
            var badgePermissions = response.data;
            $scope.permittedBadgesCount = badgePermissions.length;
            $scope.indirectPermittedBadgesCount = 0;
            _.forEach(badgePermissions, function (badgePermission) {
              // Find the badge
              var badge = _.findWhere($scope.badges, {
                id: badgePermission.entityId
              });
              if (badge !== undefined && badge !== null) {
                badge.hasPermission = true;
                if ($scope.isPerson && badgePermission.personId && badgePermission.personId === $scope.entityId) {
                  badge.directPermission = true;
                } else if (!$scope.isPerson && badgePermission.groupId && badgePermission.groupId === $scope.entityId) {
                  badge.directPermission = true;
                } else {
                  $scope.indirectPermittedBadgesCount++;
                }
              }
            });
            $scope.badgeRows = makeRows($scope.badges, ($scope.badges.length + 2) / 3);
            $scope.loading = false;
          });
        }
      });
    };
    $scope.save = function () {
      var permittedBadgeIds = [];
      _.forEach($scope.badges, function (badge) {
        if (badge.directPermission) {
          permittedBadgeIds.push(badge.id);
        }
      });
      $http.post(Api.url("/app-permissions/update-badge-permissions?_limit=1000&" + ($scope.isPerson ? "personId=" : "groupId=") + $scope.entityId), {
        entityId: $scope.entityId,
        badgeIds: permittedBadgeIds
      }).then(function success() {
        updateCachedPermissions($scope.originalEntity, $scope.isPerson, permittedBadgeIds);
        Alerts.raiseAlert({
          type: "success",
          text: $scope.permissionEntity.name + " badge permissions updated"
        });
      });
    };
    var updateCachedPermissions = function updateCachedPermissions(entity, isPerson, permittedBadgeIds) {
      _.each(BadgePermissionSvc.__permissionMap, function (permission, badgeId) {
        badgeId = parseInt(badgeId);
        // Add if missing
        if (_.contains(permittedBadgeIds, badgeId)) {
          if (!_.contains(isPerson ? permission.peopleIds : permission.groupIds, entity.id)) {
            if (isPerson) {
              permission.peopleIds.push(entity.id);
              permission.people.push(entity);
            } else {
              permission.groupIds.push(entity.id);
              permission.groups.push(entity);
            }
          }
        } else {
          // remove if needed
          if (_.contains(isPerson ? permission.peopleIds : permission.groupIds, entity.id)) {
            if (isPerson) {
              permission.peopleIds = _.without(permission.peopleIds, entity.id);
              permission.people = _.filter(permission.people, function (person) {
                return person.id !== entity.id;
              });
            } else {
              permission.groupIds = _.without(permission.groupIds, entity.id);
              permission.groups = _.filter(permission.groups, function (group) {
                return group.id !== entity.id;
              });
            }
          }
        }
      });
    };
    $scope.cancel = function () {
      $scope.permissionEntity = null;
    };
    function makeRows(arr, size) {
      var newArr = [];
      for (var i = 0; i < arr.length; i += size) {
        newArr.push(arr.slice(i, i + size));
      }
      return newArr;
    }
  }]);
})();
